import { Component } from 'react';
import ReactDOM from 'react-dom';

let appRoot = document.getElementById('root');
let body = document.getElementById('body')
let htmlRoot = document.getElementsByTagName( 'html' )[0];

class ModalCurtain extends Component {

  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.className="modal-curtain"
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
    this.toggleNoScroll();
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
    this.toggleNoScroll();
  }

  toggleNoScroll() {
    this.toggleBodyNoScrollClass();
    this.toggleAppRootNoScollClass();
    this.toggleHtmlRootNoScollClass();
  }

  toggleHtmlRootNoScollClass() {
    if (htmlRoot.classList.contains('no-scroll')) {
     htmlRoot.classList.remove('no-scroll');
    } else {
      htmlRoot.classList.add('no-scroll');
    }
  }

  toggleAppRootNoScollClass() {
    if (appRoot.classList.contains('no-scroll')) {
     appRoot.classList.remove('no-scroll');
    } else {
      appRoot.classList.add('no-scroll');
    }
  }

  toggleBodyNoScrollClass() {
    if (body.classList.contains('no-scroll')) {
     body.classList.remove('no-scroll');
    } else {
      body.classList.add('no-scroll');
    }
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default ModalCurtain


// WEBPACK FOOTER //
// ./src/components/Modals/ModalCurtain.js